<template>
  <div class="mit-manage-reports-low-inventory-page mit-page">
      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Report - Keys Low Inventory</v-card-title>
            <v-card-subtitle class="caption">Key with low inventory and availability counts</v-card-subtitle>
            <v-divider></v-divider>
            <MitKeysCountsList />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import {MitEventBus} from '../../main.js';
  import MitKeysCountsList from '../../components/keys/MitKeysCountsList.vue'

  export default {
    name: 'MitManageReportsLowInventoryPage',
    components: {
      MitKeysCountsList
    },
    data: function() {
      return {
      }
    },
    mounted() {
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
